import _actions_get from './_actions/get.js'
import _mutations_orders from './_mutations/orders.js'
import _mutations_loading from './_mutations/loading.js'
import _mutations_events from './_mutations/events.js'
import _mutations_chart from './_mutations/chart.js'
import _mutations_buttons from './_mutations/buttons.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        buttons: _mutations_buttons,
        chart: _mutations_chart,
        events: _mutations_events,
        loading: _mutations_loading,
        orders: _mutations_orders,
    },
    actions:{
        get: _actions_get,
    },
}